var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3120_62645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7096 12.7769L9.92517 1.09483C9.72866 0.761613 9.44758 0.485219 9.1099 0.293142C8.77221 0.101065 8.38969 0 8.00039 0C7.61108 0 7.22856 0.101065 6.89088 0.293142C6.55319 0.485219 6.27212 0.761613 6.07561 1.09483L0.291171 12.7769C0.100493 13.1002 0 13.4681 0 13.8426C0 14.2172 0.100493 14.585 0.291171 14.9084C0.485502 15.2433 0.76619 15.5208 1.10444 15.7127C1.44268 15.9045 1.82631 16.0036 2.21595 15.9999H13.7848C14.1742 16.0033 14.5575 15.9041 14.8955 15.7123C15.2334 15.5205 15.5139 15.243 15.7081 14.9084C15.899 14.5852 15.9997 14.2174 16 13.8428C16.0003 13.4683 15.9 13.1004 15.7096 12.7769ZM14.0959 13.9846C14.0644 14.0379 14.0189 14.0817 13.9643 14.1115C13.9096 14.1413 13.8479 14.1559 13.7856 14.1538H2.21595C2.15365 14.1559 2.09192 14.1413 2.0373 14.1115C1.98267 14.0817 1.93718 14.0379 1.90563 13.9846C1.87886 13.9414 1.86469 13.8918 1.86469 13.8411C1.86469 13.7904 1.87886 13.7408 1.90563 13.6976L7.69007 2.01558C7.72366 1.96431 7.76964 1.92217 7.82384 1.893C7.87803 1.86383 7.93872 1.84855 8.00039 1.84855C8.06205 1.84855 8.12274 1.86383 8.17694 1.893C8.23113 1.92217 8.27712 1.96431 8.31071 2.01558L14.0944 13.6976C14.1214 13.7406 14.1358 13.7902 14.1361 13.8409C14.1364 13.8915 14.1225 13.9413 14.0959 13.9846Z",
    fill: "#E3A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9L7 6C7 5.44771 7.44772 5 8 5C8.55229 5 9 5.44772 9 6L9 9Z",
    fill: "#E3A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55229 11 9 11.4477 9 12Z",
    fill: "#E3A300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3120_62645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNAttention);
export default __webpack_public_path__ + "static/media/icon-n-attention.705216ac0801eaacc1df2e826329fc0c.svg";
export { ForwardRef as ReactComponent };